import React from 'react';
import { getIn } from 'seamless-immutable';
import BuyBox from '@catalogo/ui-americanas-desktop-buybox';
import OutOfStockDisclaimer from '@catalogo/ui-americanas-mobile-out-of-stock-disclaimer';
// import SellerReputation from '@catalogo/ui-americanas-mobile-seller-reputation';
import OffersBox from './offers-box';
import { ExclusivePrime } from './exclusive-prime';
import BuyArea from './buy-area';
import { DeliveryFlow } from './delivery-flow';
import MoreOffers from './more-offers';
import * as Styled from './styles';

export const ProductOffer = props => {
  const { currentSku, product } = props;
  const offer = getIn(currentSku, ['offers', 'result', '0']);
  const hasOffer = !!offer;
  const primeDiscount = getIn(offer, ['bestPaymentOption', 'hasPrimeDiscount']);
  const isDigital = getIn(product, ['isDigital']);
  const hasDelivery = hasOffer && !isDigital;
  const offersQuantity = getIn(currentSku, ['offers', 'meta', 'total'], 0);
  const hasMoreOffers = offersQuantity > 1;

  return (
    <Styled.Container>
      <Styled.StickyContainer>
        <Styled.TopWrapper>
          {primeDiscount && (
            <Styled.ProductOfferBox>
              <ExclusivePrime />
            </Styled.ProductOfferBox>
          )}
          <Styled.ProductOfferBox $padding={hasOffer ? '24px 16px 16px' : '16px'}>
            {hasOffer ? (
              <BuyBox {...props} isNurslingProduct={product?.compliance?.nursling} />
            ) : (
              <OutOfStockDisclaimer {...props} />
            )}
          </Styled.ProductOfferBox>
          {hasDelivery && (
            <Styled.ProductOfferBox>
              <DeliveryFlow {...props} />
            </Styled.ProductOfferBox>
          )}
          {hasOffer && (
            <>
              <BuyArea {...props} />
              <OffersBox {...props} />
            </>
          )}
        </Styled.TopWrapper>
        <Styled.BottomWrapper>
          {/* <SellerReputation {...props} /> */}
          {hasMoreOffers && (
            <MoreOffers offersQuantity={offersQuantity - 1} currentSku={currentSku} product={product} />
          )}
        </Styled.BottomWrapper>
      </Styled.StickyContainer>
    </Styled.Container>
  );
};

export default ProductOffer;
